import React, { ReactNode } from 'react';
import styled, { createGlobalStyle } from 'styled-components';

interface LandingWrapperProps {
  children: ReactNode;
}

const LandingWrapper: React.FC<LandingWrapperProps> = ({ children }) => {
  return (
    <>
      <GlobalStyleReset />
      <Wrapper>{children}</Wrapper>
    </>
  );
};

export default LandingWrapper;

const GlobalStyleReset = createGlobalStyle`
  h1, h2, h3, h4, h5, h6, p {
    all: unset;
    display: block;
    font-family: initial;
    font-size: initial;
    line-height: normal;
    font-weight: normal;
    margin: 0;
    padding: 0;

    @media (min-width: 768px) {
        max-width: 1036px !important;
    }
`;

const Wrapper = styled.div`
  all: unset;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;

  @media (min-width: 768px) {
    padding: 0 74px;
  }
  @media (min-width: 1024px) {
    padding: 0 60px;
  }
`;
